import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import InviteForm from "../components/invite-form.js";
export default {
    execute: async () => {
        const { form, submitBtn } = InviteForm.get();
        const payload = { email: form.email.value.trim().toLowerCase() };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/invite-user', payload);
        formRequest.afterResponse(true);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `An email was sent with a private sign up link to <br><br> <strong>${payload.email}</strong>`,
                onRedirect: '/'
            });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
